var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    { staticClass: "border-bottom py-3", attrs: { "align-v": "center" } },
    [
      _c(
        "b-col",
        { staticClass: "mb-2 mb-md-0 text-center", attrs: { md: "2" } },
        [
          _c("b-img", {
            attrs: { src: _vm.item.image, height: "200", fluid: "" },
          }),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { md: "" } },
        [
          _c("h4", [
            _c("a", { attrs: { href: _vm.item.url } }, [
              _vm._v(_vm._s(_vm.item.name)),
            ]),
          ]),
          _c("p", { staticClass: "mb-0" }, [
            _c("strong", [_vm._v("Ref:")]),
            _vm._v(" " + _vm._s(_vm.item.sku)),
          ]),
          _vm._l(_vm.item.attributes, function (attr, name) {
            return _c("p", { key: name, staticClass: "mb-0" }, [
              _c("strong", [_vm._v(_vm._s(name) + ":")]),
              _vm._v(" " + _vm._s(attr)),
            ])
          }),
          _c(
            "b-alert",
            {
              staticClass: "d-inline-block",
              attrs: {
                show: !_vm.item.isDeliveryAvailable,
                variant: "warning",
              },
            },
            [_vm._v("This item is collection only due to it's size.")]
          ),
        ],
        2
      ),
      _c(
        "b-col",
        { attrs: { md: "2" } },
        [
          _c(
            "b-form-group",
            {
              staticClass: "mb-0",
              attrs: {
                state: _vm.item.inStock,
                "invalid-feedback": "Not enough in stock",
              },
            },
            [
              _c(
                "b-input-group",
                { staticClass: "mb-2 mb-md-0" },
                [
                  _c("b-form-input", {
                    attrs: {
                      type: "number",
                      min: "1",
                      step: "1",
                      number: "",
                      state: _vm.item.inStock,
                    },
                    model: {
                      value: _vm.item.quantity,
                      callback: function ($$v) {
                        _vm.$set(_vm.item, "quantity", $$v)
                      },
                      expression: "item.quantity",
                    },
                  }),
                  _c(
                    "b-input-group-append",
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "danger" },
                          on: { click: _vm.deleteItem },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("delete"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-col", { staticClass: "text-right", attrs: { md: "1" } }, [
        _c("strong", { staticClass: "d-md-none" }, [_vm._v("Unit Price:")]),
        _vm._v(" £" + _vm._s(_vm.item.price)),
      ]),
      _c("b-col", { staticClass: "text-right", attrs: { md: "1" } }, [
        _c("strong", { staticClass: "d-md-none" }, [_vm._v("Subtotal:")]),
        _vm._v(" £" + _vm._s(_vm.item.subtotal)),
        _vm.item.totalDiscount != "0.00"
          ? _c("small", [
              _c("br"),
              _c("em", [_vm._v("Save £" + _vm._s(_vm.item.totalDiscount))]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }